import { Component } from 'react';
import { Container, ListGroup } from 'react-bootstrap';
import { NavLink } from 'react-router-dom';

import 'bootstrap/dist/css/bootstrap.min.css';

import './QuizList.css';
import apiClient from "../../../framework/web/ApiClient";

interface Quiz {
    quizId: number,
    name: string;
    quizCode: string;
    timeLimit: number;
    passingScore: number;
}

interface State {
    quizzes: Quiz[];
    loading: boolean;
    error: string | null;
}

const PAGE_TITLE = "AMS - Test";

class QuizList extends Component<{}, State> {

    constructor(props: {}) {
        super(props);
        this.state = {
            quizzes: [],
            loading: true,
            error: null,
        };
    }

    componentDidMount() {
        document.title = PAGE_TITLE;
        this.fetchAllQuizzes();
    }

    fetchAllQuizzes = async () => {
        const headers = {
            'Access-Control-Allow-Origin': '*',
            "Content-Type": "application/json"
        };
        apiClient.get('/ams/api/v1/researcher-trainings/quizzes', { withCredentials: true, headers })
            .then(response => {
                if (response.status != 204) {
                    this.setState({ quizzes: response.data.data, loading: false });
                }
            }).catch(error => {
                this.setState({ error: 'Error fetching questions', loading: false });
            });
    };

    render() {
        const { quizzes, loading, error } = this.state;

        if (loading) {
            return <div>Loading...</div>;
        }

        if (error) {
            return <div>{error}</div>;
        }

        return (
           <Container fluid>
              <h2 className="d-block mb-4">Researcher Training Test</h2>
              <h6>Please select a test below.</h6>
              <div className="constrained-left">
                 <ListGroup as="ol" numbered>
                    {quizzes.map((quiz, index) => (
                       <ListGroup.Item as="li" key={quiz.quizId} action className="d-flex">
                          <NavLink to={`?page=quiz-start&quizId=${quiz.quizId}`} className="nav-link">
                             &nbsp;{quiz.name}
                          </NavLink>
                       </ListGroup.Item>
                    ))}
                 </ListGroup>
              </div>
           </Container>
        )
    };
}

export default QuizList;
